// Homepage Character select shop (sections/ssc-char-select.liquid, prompt 77). 1st tap/click on a world = the strip and the
// slider switch to it; 2nd tap/click on the same world = its collection. A world opens only when it is "armed" by a real
// tap/click (or an arrow-key pick): the world the page starts on isn't armed, and the fake mouseover a phone fires before
// its click is ignored. Hover (desktop) only starts loading early, it never switches.
// Cards: the starting world's are in the page; others come from sections/ssc-cs-products.liquid (Section Rendering API,
// best-selling), fetched once per world (memory + sessionStorage). The place pill comes from window.SSCWars (assets/ssc-wars.js).
(function () {
  var root = document.querySelector('[data-ssc-cs]');
  if (!root) return;
  var grid = root.querySelector('[data-cs-grid]');
  var strip = root.querySelector('[data-cs-strip]');
  var icon = root.querySelector('[data-cs-icon]');
  var nameEl = root.querySelector('[data-cs-name]');
  var countEl = root.querySelector('[data-cs-count]');
  var go = root.querySelector('[data-cs-go]');
  var goName = root.querySelector('[data-cs-go-name]');
  var wars = root.querySelector('[data-cs-wars]');
  var list = root.querySelector('[data-cs-list]');
  var retry = root.querySelector('[data-cs-retry]');
  var prev = root.querySelector('[data-cs-prev]');
  var next = root.querySelector('[data-cs-next]');
  var live = root.querySelector('[data-cs-live]');
  var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-cs]'));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = window.matchMedia('(hover: hover)').matches;
  var COLS = 5;
  var TOUCH_QUIET = 700;
  var TTL = 15 * 60 * 1000;
  var STORE = 'ssc-cs-v1:';
  var sel = tiles.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0] || tiles[0];
  var armed = null;
  var lastTouch = 0;
  var cache = {};
  var inflight = {};
  var hoverTimer = 0;
  var near = false;
  if (sel) cache[sel.dataset.cs] = list.innerHTML;

  function title(label) { return label.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); }); }

  // ---------- data ----------
  function load(tile) {
    var key = tile.dataset.cs;
    if (cache[key] != null) return Promise.resolve(cache[key]);
    if (inflight[key]) return inflight[key];
    try {
      var hit = JSON.parse(sessionStorage.getItem(STORE + key) || 'null');
      if (hit && Date.now() - hit.t < TTL && hit.h) { cache[key] = hit.h; return Promise.resolve(hit.h); }
    } catch (e) { /* ignore */ }
    inflight[key] = fetch(tile.dataset.csUrl + '?section_id=ssc-cs-products&sort_by=best-selling', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        var tpl = document.createElement('template');
        tpl.innerHTML = txt;
        var ul = tpl.content.querySelector('[data-cs-cards]');
        if (!ul || !ul.querySelector('li')) throw new Error('no cards');
        var html = ul.innerHTML.trim();
        cache[key] = html;
        delete inflight[key];
        try { sessionStorage.setItem(STORE + key, JSON.stringify({ t: Date.now(), h: html })); } catch (e) { /* ignore */ }
        return html;
      })
      .catch(function (err) { delete inflight[key]; throw err; });
    return inflight[key];
  }

  // ---------- photos ----------
  // Card photos get their URL only once the slider is near the screen (or after a tap), so the homepage downloads no
  // photos for this section on load. The browser's lazy loading then handles the cards scrolled sideways.
  function photos() {
    if (!near) return;
    list.querySelectorAll('img[data-cs-src]').forEach(function (img) {
      img.srcset = img.getAttribute('data-cs-srcset');
      img.src = img.getAttribute('data-cs-src');
      img.removeAttribute('data-cs-src');
      img.removeAttribute('data-cs-srcset');
    });
  }
  function nearNow() { near = true; photos(); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); nearNow(); }
    }, { rootMargin: '300px 0px' });
    io.observe(list);
  } else {
    nearNow();
  }

  // ---------- slider ----------
  var SKEL = '<li class="ssc-cs__card is-skel" aria-hidden="true"><div class="ssc-cs__link"><span class="ssc-cs__ph"></span>' +
    '<span class="ssc-cs__nm">&nbsp;</span><span class="ssc-cs__ty">&nbsp;</span><span class="ssc-cs__pr">&nbsp;</span></div></li>';
  function cards(html, tile) {
    var focusRetry = document.activeElement === retry;
    retry.hidden = true;
    list.classList.remove('is-err');
    list.removeAttribute('aria-busy');
    list.innerHTML = html;
    list.scrollLeft = 0;
    photos();
    arrows();
    if (focusRetry) {
      var first = list.querySelector('a');
      if (first) first.focus({ preventScroll: true });
    }
    if (tile) live.textContent = title(tile.dataset.csLabel) + ' best sellers shown.';
  }
  function skeleton() {
    retry.hidden = true;
    list.classList.remove('is-err');
    list.setAttribute('aria-busy', 'true');
    list.innerHTML = SKEL + SKEL + SKEL + SKEL;
    list.scrollLeft = 0;
    arrows();
  }
  function failed() {
    list.classList.add('is-err');
    list.removeAttribute('aria-busy');
    retry.hidden = false;
    live.textContent = "Couldn't load the products.";
  }
  function fill(tile) {
    var key = tile.dataset.cs;
    if (cache[key] != null) { cards(cache[key], tile); return; }
    skeleton();
    load(tile).then(function (html) { if (sel === tile) cards(html, tile); }).catch(function () { if (sel === tile) failed(); });
  }
  function arrows() {
    if (!prev || !next) return;
    var on = hover && window.innerWidth >= 990 && list.scrollWidth > list.clientWidth + 2;
    prev.hidden = !on || list.scrollLeft <= 2;
    next.hidden = !on || list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  }
  function page(dir) {
    var card = list.querySelector('li');
    var step = card ? card.getBoundingClientRect().width + 12 : list.clientWidth / 2;
    // Prompt 124: one card per click (it used to page by a screenful).
    list.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
  }

  // ---------- strip ----------
  // Long names (BLACK CLOVER on a phone) shrink until they fit on one line, down to 15px.
  function fitName() {
    nameEl.style.fontSize = '';
    var size = parseFloat(getComputedStyle(nameEl).fontSize);
    while (nameEl.scrollWidth > nameEl.clientWidth + 1 && size > 15) {
      size -= 1;
      nameEl.style.fontSize = size + 'px';
    }
  }
  function paintWars() {
    if (!wars || !sel) return;
    var chip = window.SSCWars && window.SSCWars.ready && window.SSCWars.chip ? window.SSCWars.chip(sel.dataset.cs) : '';
    wars.innerHTML = chip ? chip + '<span class="ssc-cs__wars-l">Anime Wars</span>' : '';
    wars.hidden = !chip;
    // One line only (the strip keeps its height): when it would wrap, the words go to screen readers only.
    wars.classList.remove('is-tight');
    if (chip && wars.parentNode.offsetHeight > countEl.offsetHeight + 8) wars.classList.add('is-tight');
  }
  function show(tile) {
    if (!tile) return;
    near = true;
    sel = tile;
    tiles.forEach(function (t) { t.setAttribute('aria-pressed', t === tile ? 'true' : 'false'); });
    var n = Number(tile.dataset.csCount) || 0;
    strip.style.setProperty('--cs-w', 'var(--world-' + tile.dataset.cs + ')');
    var svg = tile.querySelector('.ssc-cs__ic svg');
    if (svg) icon.replaceChildren(svg.cloneNode(true));
    nameEl.textContent = tile.dataset.csLabel;
    fitName();
    countEl.textContent = n + ' item' + (n === 1 ? '' : 's');
    go.href = tile.dataset.csUrl;
    if (goName) goName.textContent = ' ' + tile.dataset.csLabel;
    list.setAttribute('aria-label', title(tile.dataset.csLabel) + ' best sellers');
    if (!reduce) { icon.classList.remove('is-pop'); void icon.offsetWidth; icon.classList.add('is-pop'); }
    paintWars();
    fill(tile);
  }

  // ---------- input ----------
  // Touch time on press and release (a slow press would otherwise outlast the quiet window before its fake mouseover).
  // The press also starts the request, so the cards are often there by the click.
  function touched(e) { if (e.pointerType !== 'mouse') lastTouch = Date.now(); }
  grid.addEventListener('pointerdown', function (e) {
    touched(e);
    var t = e.target.closest('[data-cs]');
    if (t) load(t).catch(function () {});
  });
  grid.addEventListener('pointerup', touched);
  grid.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cs]');
    if (!t) return;
    // Keyboard Enter / Space (a click with no pointer) on the selected world shops it, like 75.
    if (t === armed || (e.detail === 0 && t === sel)) { location.href = t.dataset.csUrl; return; }
    armed = t;
    if (t !== sel) show(t);
  });
  if (hover) {
    grid.addEventListener('mouseover', function (e) {
      // Phones fire a mouseover right before the click of a tap: never act on it.
      if (Date.now() - lastTouch < TOUCH_QUIET) return;
      var t = e.target.closest('[data-cs]');
      clearTimeout(hoverTimer);
      if (t && cache[t.dataset.cs] == null) hoverTimer = setTimeout(function () { load(t).catch(function () {}); }, 120);
    });
    grid.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
  }
  grid.addEventListener('keydown', function (e) {
    var i = tiles.indexOf(document.activeElement);
    if (i < 0) return;
    var step = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: COLS, ArrowUp: -COLS }[e.key];
    if (!step) return;
    e.preventDefault();
    var to = tiles[Math.min(tiles.length - 1, Math.max(0, i + step))];
    to.focus();
    armed = to;
    if (to !== sel) show(to);
  });
  retry.addEventListener('click', function () { fill(sel); });
  if (prev && next) {
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    list.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();
  }

  // Grid columns follow the CSS (5 on phones, 11 on desktop) for the arrow keys.
  function cols() {
    var c = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    COLS = c > 0 ? c : 5;
  }
  cols();
  window.addEventListener('resize', cols);

  window.addEventListener('resize', function () { fitName(); paintWars(); });
  fitName();
  document.addEventListener('ssc-wars:standings', paintWars);
  paintWars();
})();
